module.exports = __webpack_public_path__ + "static/media/Crazy Scientist (Series 14).4bb61d92.jpg";